<template>
  <div>
    <table class="service_table">
      <tr>
        <th>URL</th>
        <td v-if="menu.facilities.facilities[0].facilityUrl">
          <a
            :href="menu.facilities.facilities[0].facilityUrl"
            target="_blank"
            class="c-text-button2"
          >
            {{ menu.facilities.facilities[0].facilityUrl }}
          </a>
        </td>
        <th>お問い合わせ</th>
        <td v-if="menu.facilities.facilities[0].facilityInqForm">
          <a
            :href="menu.facilities.facilities[0].facilityInqForm"
            target="_blank"
            class="c-text-button2"
          >
            提供企業お問い合わせフォーム
            <Icon name="action_link" :color="$colors.sub.blue" />
          </a>
        </td>
        <td v-else></td>
      </tr>
    </table>
    <span>
          ［注意事項］ 店舗情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。
        </span>
  </div>
</template>

<script>
export default {
  props: {
    menu: {
      type: Object,
    },
  },
  computed: {
    getRegularlyClosedsText() {
      let text = '';
      if (this.menu.facilities.facilities[0].regularlyCloseds
      && this.menu.facilities.facilities[0].regularlyCloseds.length > 0) {
        const list = this.menu.facilities.facilities[0].regularlyCloseds;
        list.forEach(data => {
          text += `${data}\n`;
        });
      }
      return text;
    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.c-text-button2 {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  vertical-align: middle;
  .c-icon {
    margin-right: 0.25em;
    margin-left: 0.25em;
  }
}
</style>
